// Per-user privacy consent + EST-baseline preferences. Stored on-device (localStorage);
// ZIP/State themselves live on the account via the location APIs. Defaults: location ON,
// usage-data OFF, EST override OFF.
const K = (uid, name) => `cdd_${name}_${uid || "anon"}`;

export function getConsent(uid) {
  let loc, usage, est;
  try {
    loc = localStorage.getItem(K(uid, "loc_consent"));
    usage = localStorage.getItem(K(uid, "usage_consent"));
    est = localStorage.getItem(K(uid, "est_override"));
  } catch { /* storage unavailable */ }
  return {
    location: loc === null || loc === undefined ? true : loc === "1",
    usage: usage === "1",
    est: est === "1",
  };
}

export function setConsent(uid, patch = {}) {
  try {
    if ("location" in patch) localStorage.setItem(K(uid, "loc_consent"), patch.location ? "1" : "0");
    if ("usage" in patch) localStorage.setItem(K(uid, "usage_consent"), patch.usage ? "1" : "0");
    if ("est" in patch) localStorage.setItem(K(uid, "est_override"), patch.est ? "1" : "0");
  } catch { /* storage unavailable */ }
  return getConsent(uid);
}

// True when the Terminal/Dashboard should show estimated regional baselines instead of
// exact ZIP-derived numbers.
export function isEstBaseline(uid, hasState) {
  const c = getConsent(uid);
  return !c.location || c.est || !hasState;
}
